import { createFileRoute } from '@tanstack/react-router';
import { AIMatchingResultsLayoutComponent } from '@/app/route-components/AIMatchingResultsLayoutComponent';
import { NotFoundPage } from '@/pages/errors/ui/NotFoundPage';

/**
 * AIマッチング結果レイアウトルート
 *
 * 二次メニュー（AIMatchingResultsMenu）とページコンテンツを横並びで配置する。
 * /projects/ai-matching-results 配下の 4 カテゴリページ（特別交付税（省令）/（調査票）/
 * 国の補助金等 / 都道府県の補助金等）の共通レイアウト。
 *
 * 配下の不正なパス（存在しないカテゴリ等）では、レイアウトの outlet 既定の素の "Not Found" ではなく
 * 共通の 404 ページを表示する。
 */
export const Route = createFileRoute('/_protected/projects/ai-matching-results')({
  component: AIMatchingResultsLayoutComponent,
  notFoundComponent: NotFoundPage,
});
